import {
  Book,
  BookOutlined,
  Bookmarks,
  BookmarksOutlined,
  BusinessCenter,
  BusinessCenterOutlined,
  Dashboard,
  DashboardOutlined,
  Equalizer,
  EqualizerOutlined,
  FactCheck,
  FactCheckOutlined,
  FiberManualRecord,
  Group,
  GroupOutlined,
  History,
  HistoryOutlined,
  Hub,
  HubOutlined,
  InsertChart,
  InsertChartOutlinedOutlined,
  Payments,
  PaymentsOutlined,
  Person,
  PersonOutlineOutlined,
  PersonSearch,
  PersonSearchOutlined,
  RemoveCircle,
  RemoveCircleOutline,
  Settings,
  SettingsOutlined,
  ShoppingBag,
  ShoppingBagOutlined,
  SvgIconComponent,
  TableChart,
  TableChartOutlined,
  TrackChanges,
  TrackChangesOutlined,
  PriceChangeOutlined,
  PriceChange,
  Note,
  NoteOutlined,
  // AccessTimeOutlined,
  PeopleOutlineOutlined,
  PeopleAlt,
  // AccessTimeFilled,
  BarChartOutlined,
  BarChart,
  // TableBarOutlined,
  // TableBar,
  // PercentOutlined,
  // Percent,
  PeopleOutlined,
  People,
  // MoreHorizOutlined,
  // MoreHoriz,
  ExitToAppOutlined,
  ReceiptLong,
  Print,
  PrintOutlined,
  ReceiptLongOutlined,
  AppBlockingOutlined,
  AppBlocking,
  SpaceDashboardOutlined,
  SpaceDashboard,
} from '@mui/icons-material';

// import { FiberManualRecord } from '../assets/icons/sidebar/Vector';
import {
  ACCG,
  ENG,
  FO,
  HK,
  HR,
  POS,
  SB,
  USER,
} from '../assets/icons/modules/v2';

import { ReactNode } from 'react';
import { appMode } from './url';

export interface AccordionTypes {
  title: string;
  link: string;
  icon: SvgIconComponent;
  activeIcon: SvgIconComponent;
  isActive: boolean;
  accordion?: AccordionTypes[];
  iconSize?: string;
  disabled?: boolean;
  onClick?: () => void;
}

export interface SideBarType {
  title: string;
  link: string;
  icon: SvgIconComponent;
  activeIcon: SvgIconComponent;
  isActive: boolean;
  accordion?: AccordionTypes[];
  disabled?: boolean;
  onClick?: () => void;
}

export interface ModuleArrState {
  code: string;
  title: string;
  link: string;
  icon: SvgIconComponent;
  disabledIcon: SvgIconComponent;
  isActive: boolean;
  sidebar: SideBarType[];
  description: string;
  disabled?: boolean;
  initialSetupModule?: ReactNode;
  showInitialSetup?: boolean;
  disableOnAllProperty?: boolean;
}

export const moduleArr: ModuleArrState[] = [
  // {
  //   code: 'ABK', //Bookeeping
  //   // code: 'AD-N/A',
  //   title: 'Administration Settings',
  //   link: '/administration-settings',
  //   icon: ACCG,
  //   disabledIcon: ACCG,
  //   isActive: true,
  //   sidebar: [
  //     {
  //       title: 'Dashboard',
  //       link: '/users-management/dashboard',
  //       icon: DashboardOutlined,
  //       activeIcon: Dashboard,
  //       isActive: true,
  //     },
  //     {
  //       title: 'Setup',
  //       link: '/users-management/setup',
  //       icon: SettingsOutlined,
  //       activeIcon: Settings,
  //       isActive: true,
  //     },
  //   ],
  //   description: `Coming Soon`,
  // },
  {
    // code: 'ACCG',
    code: 'ABK', //Bookeeping
    title: 'Accounting and Finance',
    link: '/accounting-and-finance',
    icon: ACCG,
    disabledIcon: ACCG,
    isActive: true,
    showInitialSetup: true,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/accounting-and-finance/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
      {
        title: 'Transactions',
        link: '/accounting-and-finance/transactions',
        icon: PaymentsOutlined,
        activeIcon: Payments,
        isActive: true,
        accordion: [
          {
            title: 'Sales',
            link: '/accounting-and-finance/transactions/sales',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Collections',
            link: '/accounting-and-finance/transactions/collections',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Purchases',
            link: '/accounting-and-finance/transactions/purchases',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Disbursements',
            link: '/accounting-and-finance/transactions/disbursements',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Adjustments',
            link: '/accounting-and-finance/transactions/adjustments',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
        ],
      },
      {
        title: 'Reports',
        link: '/accounting-and-finance/reports',
        icon: EqualizerOutlined,
        activeIcon: Equalizer,
        isActive: true,
        accordion: [
          {
            title: 'Ledgers',
            link: '/accounting-and-finance/reports/ledgers',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            accordion: [
              {
                title: 'Account Ledger',
                link: '/accounting-and-finance/reports/ledgers/account-ledger',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Supplier Ledger',
                link: '/accounting-and-finance/reports/ledgers/supplier-ledger',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Customer Ledger',
                link: '/accounting-and-finance/reports/ledgers/customer-ledger',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Check Issuance Report',
                link: '/accounting-and-finance/reports/ledgers/check-issuance-report',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
            ],
          },
          {
            title: 'Schedules',
            link: '/accounting-and-finance/reports/schedules',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            accordion: [
              {
                title: 'AP Aging',
                link: '/accounting-and-finance/reports/schedules/aging-payables',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'AR Aging',
                link: '/accounting-and-finance/reports/schedules/aging-receivables',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'AR Schedule',
                link: '/accounting-and-finance/reports/schedules/ar-schedule',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
            ],
          },
          {
            title: 'Book of Account',
            link: '/accounting-and-finance/reports/book-of-account',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            accordion: [
              {
                title: 'General Journal',
                link: '/accounting-and-finance/reports/book-of-account/general-journal',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
              {
                title: 'General Ledger',
                link: '/accounting-and-finance/reports/book-of-account/general-ledger',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
              {
                title: 'Sales Journal',
                link: '/accounting-and-finance/reports/book-of-account/sales-journal',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
              {
                title: 'Purchase Journal',
                link: '/accounting-and-finance/reports/book-of-account/purchase-journal',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
              {
                title: 'Cash Receipts Book',
                link: '/accounting-and-finance/reports/book-of-account/cash-receipts-book',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
              {
                title: 'Cash Disbursement Book',
                link: '/accounting-and-finance/reports/book-of-account/cash-disbursement-book',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
            ],
          },
          {
            title: 'Working Trial Balance',
            link: '/accounting-and-finance/reports/working-trial-balance',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Trial Balance',
            link: '/accounting-and-finance/reports/trial-balance',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Financial Statements',
            link: '/accounting-and-finance/reports/financial-statements',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            accordion: [
              {
                title: 'Balance Sheet',
                link: '/accounting-and-finance/reports/financial-statements/balance-sheet',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
              {
                title: 'Profit and Loss',
                link: '/accounting-and-finance/reports/financial-statements/profit-and-loss',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                // iconSize: '8px',
              },
            ],
          },
          {
            title: 'BIR Reports',
            link: '/accounting-and-finance/reports/bir',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            accordion: [
              {
                title: 'Alphabetical List of Payees',
                link: '/accounting-and-finance/reports/bir/alpha-list-payees',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Summary Alphalist of Withholding Taxes',
                link: '/accounting-and-finance/reports/bir/summary-withholding-tax',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
            ],
          },
          // {
          //   title: 'USALI Reports',
          //   link: '/accounting-and-finance/reports/usali',
          //   icon: FiberManualRecord,
          //   activeIcon: FiberManualRecord,
          //   isActive: false,
          //   iconSize: '8px',
          // },
          // {
          //   title: 'Transaction Logs',
          //   link: '/accounting-and-finance/reports/transaction-logs',
          //   icon: FiberManualRecord,
          //   activeIcon: FiberManualRecord,
          //   isActive: true,
          //   iconSize: '8px',
          // },
          {
            title: 'Audit Logs',
            link: '/accounting-and-finance/reports/audit-logs',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Masterlist',
            link: '/accounting-and-finance/reports/masterlist',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            accordion: [
              {
                title: 'Chart of Accounts',
                link: '/accounting-and-finance/reports/masterlist/chart-of-accounts',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Customers',
                link: '/accounting-and-finance/reports/masterlist/customers',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Suppliers',
                link: '/accounting-and-finance/reports/masterlist/list-of-suppliers',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Products and Services',
                link: '/accounting-and-finance/reports/masterlist/products-and-services',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Profit Centers',
                link: '/accounting-and-finance/reports/masterlist/profit-centers',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Departments',
                link: '/accounting-and-finance/reports/masterlist/departments',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Projects',
                link: '/accounting-and-finance/reports/masterlist/projects',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Check Book',
                link: '/accounting-and-finance/reports/masterlist/check-book',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
            ],
          },
        ],
      },
      {
        title: 'Setup',
        link: '/accounting-and-finance/setup',
        icon: SettingsOutlined,
        activeIcon: Settings,
        isActive: true,
      },
    ],
    description: `Coming Soon`,
  },
  {
    code: 'FO',
    title: 'Front Office',
    link: '/front-office',
    icon: FO,
    disabledIcon: FO,
    isActive: true,
    showInitialSetup: true,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/front-office/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
      {
        title: 'Rates & Availability',
        link: '/front-office/rates-and-availability',
        icon: TableChartOutlined,
        activeIcon: TableChart,
        isActive: true,
      },
      {
        title: 'Bookings',
        link: '/front-office/bookings',
        icon: BookOutlined,
        activeIcon: Book,
        isActive: true,
        accordion: [
          {
            title: 'Reservations',
            link: '/front-office/bookings/reservations',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Group List',
            link:
              appMode === 'local' || appMode === 'development'
                ? '/front-office/bookings/group-list'
                : '#',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Pendings',
            link: '/front-office/bookings/pending-list',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Cancelled',
            link: '/front-office/bookings/cancelled',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Masterlist',
            link: '/front-office/bookings/masterlist',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Booking Engine',
            link: '/front-office/bookings/booking-engine',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Channel Manager',
            link: '/front-office/bookings/channel-manager',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
        ],
      },
      {
        title: 'Profile',
        link: '/front-office/profile',
        icon: GroupOutlined,
        activeIcon: Group,
        isActive: true,
        accordion: [
          {
            title: 'Individual / FIT',
            link: '/front-office/profile/individual',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Group / Company',
            link: '/front-office/profile/group',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
        ],
        disabled: false,
      },
      {
        title: 'Room Blockings',
        link: '/front-office/room-blockings',
        icon: RemoveCircleOutline,
        activeIcon: RemoveCircle,
        isActive: true,
      },
      {
        title: 'City Ledger',
        link: '/front-office/city-ledger',
        icon: BusinessCenterOutlined,
        activeIcon: BusinessCenter,
        isActive: true,
      },
      {
        title: 'Room Posting',
        link: '/front-office/room-posting',
        icon: BookmarksOutlined,
        activeIcon: Bookmarks,
        isActive: true,
      },
      {
        title: 'Reports',
        link: '/front-office/reports',
        // link: '#',
        icon: InsertChartOutlinedOutlined,
        activeIcon: InsertChart,
        isActive: true,
        accordion: [
          {
            title: 'Actual and Forecast Report',
            link: '/front-office/reports/actual-and-forecast-report',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Collections - AR',
            link: '/front-office/reports/collections-ar',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Collections - Detailed',
            link: '/front-office/reports/collections-detailed',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Collections - Summary',
            link: '/front-office/reports/collections-summary',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Journal Entries Report',
            link: '/front-office/reports/journal-entries',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Logs Report',
            link: '/front-office/reports/logs-report',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: "Manager's Flash Report",
            link: '/front-office/reports/manager-flash-report',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },

          {
            title: 'Nationality Report',
            link: '/front-office/reports/nationality-report',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Room Events History',
            link: '/front-office/reports/room-events-history',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'List of ARs Issued Report',
            link: '/front-office/reports/acknowledgement-receipts',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          // {
          //   title: 'List of SIs Issued Report',
          //   link: '/front-office/reports/sales-invoices',
          //   icon: FiberManualRecord,
          //   activeIcon: FiberManualRecord,
          //   isActive: true,
          //   iconSize: '8px',
          //   disabled: false,
          // },
          {
            title: 'Transactions Report',
            link: '/front-office/reports/transactions',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Voided Items Report',
            link: '/front-office/reports/voided-items',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Charging Station Report',
            link: '/front-office/reports/charging-station',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Cash Breakdown Report',
            link: '/front-office/reports/cash-breakdown-report',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          // {
          //   title: 'Visit History',
          //   link: '/front-office/reports/visit-history',
          //   icon: FiberManualRecord,
          //   activeIcon: FiberManualRecord,
          //   isActive: true,
          //   iconSize: '8px',
          //   disabled: false,
          // },
        ].sort((a, b) => a.title.localeCompare(b.title)),
      },
      {
        title: 'Print Blank Reg Form',
        link: '/front-office/blank-reg-form',
        icon: NoteOutlined,
        activeIcon: Note,
        isActive: true,
      },
      {
        title: 'Charging Station',
        link: '/front-office/charging-station',
        // link: '#',
        icon: HubOutlined,
        activeIcon: Hub,
        isActive: true,
      },
      {
        title: 'Traces',
        link: '/front-office/traces',
        // link: '#',
        icon: TrackChangesOutlined,
        activeIcon: TrackChanges,
        isActive: true,
      },
      {
        title: 'Declare New Day',
        link: '/front-office/declare-new-day',
        icon: FactCheckOutlined,
        activeIcon: FactCheck,
        isActive: true,
      },
      {
        title: 'Cash Breakdown',
        link: '/front-office/cash-breakdown',
        icon: PriceChangeOutlined,
        activeIcon: PriceChange,
        isActive: true,
      },
      {
        title: 'Setup',
        link: '/front-office/setup',
        icon: SettingsOutlined,
        activeIcon: Settings,
        isActive: true,
      },
      // {
      //   title: 'PDF',
      //   link:
      //     appMode === 'local' || appMode === 'development'
      //       ? '/front-office/pdf'
      //       : '#',
      //   icon: FileOpenOutlined,
      //   activeIcon: FileOpen,
      //   isActive: true,
      // },
    ],
    description: `Coming Soon`,
  },
  {
    code: 'HK',
    title: 'Housekeeping',
    link: '/housekeeping-management',
    icon: HK,
    disabledIcon: HK,
    isActive: false,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/housekeeping-management/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
    ],
    description: `Coming Soon`,
  },
  {
    // code: 'HR',
    code: 'HRD',
    title: 'Human Resources',
    link: '/human-resources',
    icon: HR,
    disabledIcon: HR,
    isActive: false,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/human-resources/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
    ],
    description: `Coming Soon`,
  },
  {
    // code: 'ENG',
    code: 'OTH', //Others
    title: 'Maintenance and Engineering',
    link: '/maintenance-and-engineering',
    icon: ENG,
    disabledIcon: ENG,
    isActive: false,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/maintenance-and-engineering/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
    ],
    description: `Coming Soon`,
  },
  {
    code: 'POS',
    title: 'Point of Sale',
    link: '/point-of-sale',
    icon: POS,
    disabledIcon: POS,
    isActive: true,
    sidebar: [
      // {
      //   title: 'Dashboard',
      //   link: '/point-of-sale/dashboard',
      //   icon: DashboardOutlined,
      //   activeIcon: Dashboard,
      //   isActive: true,
      // },
      // {
      //   title: 'Table Select',
      //   link: '/point-of-sale/table-select',
      //   icon: TableBarOutlined,
      //   activeIcon: TableBar,
      //   isActive: true,
      // },
      // {
      //   title: 'Discount',
      //   link: '/point-of-sale/discount',
      //   icon: PercentOutlined,
      //   activeIcon: Percent,
      //   isActive: true,
      // },
      {
        title: 'Main',
        link: '/point-of-sale/dashboard',
        icon: SpaceDashboardOutlined,
        activeIcon: SpaceDashboard,
        isActive: true,
      },
      {
        title: 'Profiles',
        link: '/point-of-sale/profiles',
        icon: PeopleOutlined,
        activeIcon: People,
        isActive: true,
        accordion: [
          {
            title: 'Individual / FIT',
            link: '/point-of-sale/profiles/individual',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Group / Company',
            link: '/point-of-sale/profiles/group',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
        ],
        disabled: false,
      },
      {
        title: 'Void Invoice',
        link: '/point-of-sale/void-invoice',
        icon: AppBlockingOutlined,
        activeIcon: AppBlocking,
        isActive: true,
      },
      {
        title: 'Reprint',
        link: '/point-of-sale/reprint',
        icon: PrintOutlined,
        activeIcon: Print,
        isActive: true,
      },
      {
        title: 'Reports',
        link: '/point-of-sale/reports',
        icon: BarChartOutlined,
        activeIcon: BarChart,
        isActive: true,
        accordion: [
          {
            title: 'Shift Reports',
            link: '/point-of-sale/reports/#',
            icon: PrintOutlined,
            activeIcon: Print,
            isActive: true,
          },
          {
            title: 'Y/Z Reading',
            link: '/point-of-sale/reports/#',
            icon: ReceiptLongOutlined,
            activeIcon: ReceiptLong,
            isActive: true,
          },
        ],
      },
      // {
      //   title: 'City Ledger',
      //   link: '/point-of-sale/city-ledger',
      //   icon: BusinessCenterOutlined,
      //   activeIcon: BusinessCenter,
      //   isActive: true,
      // },
      // {
      //   title: 'Traces',
      //   link: '/point-of-sale/traces',
      //   icon: TrackChangesOutlined,
      //   activeIcon: TrackChanges,
      //   isActive: true,
      // },
      {
        title: 'End Shift',
        link: '/point-of-sale/end-shift',
        icon: ExitToAppOutlined,
        activeIcon: FactCheck,
        isActive: true,
      },
      {
        title: 'Declare New Day',
        link: '/point-of-sale/declare-new-day',
        icon: FactCheckOutlined,
        activeIcon: FactCheck,
        isActive: true,
      },
      // {
      //   title: 'Misc',
      //   link: '/point-of-sale/misc',
      //   icon: MoreHorizOutlined,
      //   activeIcon: MoreHoriz,
      //   isActive: true,
      // },
    ],
    description: `Coming Soon`,
    disableOnAllProperty: true,
  },
  {
    code: 'BO',
    title: 'BO',
    link: '/back-office',
    icon: POS,
    disabledIcon: POS,
    isActive: true,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/back-office/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
      {
        title: 'Item Management',
        link: '/back-office/itemmanagement',
        icon: ShoppingBagOutlined,
        activeIcon: ShoppingBag,
        isActive: true,
        accordion: [
          {
            title: 'Menu Lists',
            link: '/back-office/item-management/menu-list',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          // {
          //   title: 'Display Management',
          //   link: '/back-office/item-management/display-management',
          //   icon: FiberManualRecord,
          //   activeIcon: FiberManualRecord,
          //   isActive: true,
          //   iconSize: '8px',
          // },
          {
            title: 'Group Display',
            link: '/back-office/item-management/group-display',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
        ],
      },
      // {
      //   title: 'Manage Schedule & Pricing',
      //   link: '/back-office/manage-scheduling-and-pricing',
      //   icon: AccessTimeOutlined,
      //   activeIcon: AccessTimeFilled,
      //   isActive: true,
      // },
      {
        title: 'Profiles',
        link: '/back-office/profiles',
        icon: PeopleOutlineOutlined,
        activeIcon: PeopleAlt,
        isActive: true,
        accordion: [
          {
            title: 'Individual / FIT',
            link: '/back-office/profiles/individual',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
          {
            title: 'Group / Company',
            link: '/back-office/profiles/group',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            disabled: false,
          },
        ],
        disabled: false,
      },
      {
        title: 'Reports',
        link: '/back-office/reports',
        icon: BarChartOutlined,
        activeIcon: BarChart,
        isActive: true,
        accordion: [
          {
            title: 'All Items List',
            link: '/back-office/reports/all-item-list',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Audit Logs',
            link: '/back-office/reports/audit-logs',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'BIR Sales Summary Report',
            link: '/back-office/reports/bir-sales-summary-report',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Statutory Discounts',
            link: '/back-office/reports/bir-discount-report',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
            accordion: [
              {
                title: 'NAAC',
                link: '/back-office/reports/bir-discount-report/naac',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'PWD',
                link: '/back-office/reports/bir-discount-report/pwd',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Senior Citizen',
                link: '/back-office/reports/bir-discount-report/sc',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
              {
                title: 'Solo Parent',
                link: '/back-office/reports/bir-discount-report/sp',
                icon: FiberManualRecord,
                activeIcon: FiberManualRecord,
                isActive: true,
                iconSize: '8px',
              },
            ],
          },
          // {
          //   title: 'Charge Slip',
          //   link: '/back-office/reports/charged-slip',
          //   icon: FiberManualRecord,
          //   activeIcon: FiberManualRecord,
          //   isActive: true,
          //   iconSize: '8px',
          // },
          {
            title: 'Collection by Shift',
            link: '/back-office/reports/collection-by-shift',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Collection by Settlement',
            link: '/back-office/reports/collection-by-settlement',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Collection Summary',
            link: '/back-office/reports/collection-summary',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'KPI Covers by Hour',
            link: '/back-office/reports/kpi-covers-by-hour',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'KPI Daily Statistics',
            link: '/back-office/reports/kpi-daily-statistics',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'KPI Sales by Hour',
            link: '/back-office/reports/kpi-sales-by-hour',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'KPI Sales by Item MTD',
            link: '/back-office/reports/kpi-sales-by-item-mtd',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Order Slip',
            link: '/back-office/reports/order-slip',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Sales by Invoice',
            link: '/back-office/reports/sales-by-invoice',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Sales by Group',
            link: '/back-office/reports/sales-by-group',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Sales by Revenue',
            link: '/back-office/reports/sales-by-revenue',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Sales by Item Type',
            link: '/back-office/reports/sales-by-item-type',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Discount Detailed',
            link: '/back-office/reports/discount-detailed',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Discount Summarized',
            link: '/back-office/reports/discount-summarized',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Transaction Journal',
            link: '/back-office/reports/transaction-journal',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
          {
            title: 'Voided Items Report',
            link: '/back-office/reports/voided-items',
            icon: FiberManualRecord,
            activeIcon: FiberManualRecord,
            isActive: true,
            iconSize: '8px',
          },
        ].sort((a, b) => a.title.localeCompare(b.title)),
      },
      {
        title: 'Setup',
        link: '/back-office/setup',
        icon: SettingsOutlined,
        activeIcon: Settings,
        isActive: true,
      },
    ],
    description: `Coming Soon`,
  },
  // {
  //   code: 'R-N/A',
  //   title: 'Reports',
  //   link: '/reports',
  //   icon: ReportsIcon,
  //   isActive: true,
  //   sidebar: [
  //     {
  //       title: 'Dashboard',
  //       link: '/users-management/dashboard',
  //       icon: DashboardOutlined,
  //       activeIcon: Dashboard,
  //       isActive: true,
  //     },
  //   ],
  //   description: `Coming Soon`,
  // },
  // {
  //   code: 'PM-N/A',
  //   title: 'Profiles',
  //   link: '/profile-management',
  //   icon: ProfilesManagementIcon,
  //   isActive: true,
  //   sidebar: [
  //     {
  //       title: 'Dashboard',
  //       link: '/users-management/dashboard',
  //       icon: DashboardOutlined,
  //       activeIcon: Dashboard,
  //       isActive: true,
  //     },
  //   ],
  //   description: `Coming Soon`,
  // },
  {
    // code: 'S&B',
    code: 'BQT',
    title: 'Sales & Banquet',
    link: '/sales-and-banquet',
    icon: SB,
    disabledIcon: SB,
    isActive: false,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/sales-and-banquet/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
    ],
    description: `Coming Soon`,
  },
  // {
  //   code: 'R-N/A',
  //   title: 'Reservations',
  //   link: '/reservation',
  //   icon: ReservationIcon,
  //   isActive: true,
  //   sidebar: [
  //     {
  //       title: 'Dashboard',
  //       link: '/users-management/dashboard',
  //       icon: DashboardOutlined,
  //       activeIcon: Dashboard,
  //       isActive: true,
  //     },
  //   ],
  //   description: `Coming Soon`,
  // },
  {
    code: 'UM',
    title: 'Users Management',
    link: '/users-management',
    icon: USER,
    disabledIcon: USER,
    isActive: true,
    sidebar: [
      {
        title: 'Dashboard',
        link: '/users-management/dashboard',
        icon: DashboardOutlined,
        activeIcon: Dashboard,
        isActive: true,
      },
      {
        title: 'Users',
        link: '/users-management/users',
        icon: PersonOutlineOutlined,
        activeIcon: Person,
        isActive: true,
      },
      {
        title: 'Roles',
        link: '/users-management/roles',
        icon: PersonSearchOutlined,
        activeIcon: PersonSearch,
        isActive: true,
      },
      {
        title: 'Settings',
        link: '/users-management/settings',
        icon: SettingsOutlined,
        activeIcon: Settings,
        isActive: true,
      },
      // {
      //   title: 'Reports',
      //   link: '/users-management/reports',
      //   icon: ContentPasteGoOutlined,
      //   activeIcon: ContentPasteGo,
      //   isActive: true,
      // },
      {
        title: 'Logs',
        link: '/users-management/logs',
        icon: HistoryOutlined,
        activeIcon: History,
        isActive: true,
      },
    ],
    description: `Key component, facilitating user registration, privilege assignment, and centralized identity management within an organization. Admins use it to control roles and update user information.`,
  },
];
